const VEHICLE_TYPE = [
    { value: 'SmallCarsAndUtilities', label: 'Carros Pequenos e Utilitários' },
    { value: 'TrucksAndMinibuses', label: 'Caminhões e Vans' },
    { value: 'Motorcycles', label: 'Motocicletas' },
];

export default VEHICLE_TYPE